<div class="inline-flex items-center" [class.opacity-50]="disabled">
  <label class="relative flex items-center m-0" [class.cursor-pointer]="!disabled">
    <input type="checkbox" class="peer sr-only" [(ngModel)]="checked" (change)="handleChange($event)" [disabled]="disabled">
    
    <div [ngClass]="checked ? 'bg-black border-black' : 'bg-white border-gray-500'" class="flex shrink-0 items-center justify-center w-[18px] h-[18px] border-2 rounded-[4px] transition-colors">
      @if (checked) {
        <svg class="w-[18px] h-[18px] text-white stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      }
    </div>
    
    @if (label) {
      <span class="ml-2.5 text-sm font-medium text-gray-900 whitespace-nowrap">{{ label }}</span>
    }
  </label>
</div>
